/*
 * @Description: 
 * @LastEditors: wjx
 * @Date: 2021-01-29 00:40:03
 */
import SlideVerify from './src/main';

SlideVerify.install = function(Vue) {
  Vue.component(SlideVerify.name, SlideVerify);
};

export default SlideVerify;



// WEBPACK FOOTER //
// ./src/packages/slide-verify/index.js